export const TASK_LIST_FLEX_TEMPLATE = [
  {
    name: 'NOM Certification',
    tasks: [
      'NOM_Project Planning',
      'NOM_Sample / Information Received',
      'NOM_Product / Information Review',
      'NOM_Language Review',
      'NOM_Preliminary Review',
      'NOM_Legal Representative Information Review',
      'NOM_Testing',
      'NOM_Project Final Review',
      'NOM_Project Completion',
      'NOM_Certificate_Office_Review',
      'NOM_Homologation certificate',
      'GMA TC_Processing (non-UL CO)',
      'NOM_Sample Disposition',
    ],
  },
]
